export default [
  {
    title: 'Submitted By',
    dataIndex: 'submittedToQueueBy',
    key: 'submittedToQueueBy',
    sorter: true,
    render: (_, { submittedToQueueBy }) => (submittedToQueueBy === '' ? 'N/A' : submittedToQueueBy)
  },
  {
    title: 'Student',
    dataIndex: 'student',
    key: 'student',
    sorter: true
  },
  {
    title: 'Contact Number',
    dataIndex: 'contactNumber',
    key: 'contactNumber'
  },
  {
    title: 'Submitted For',
    dataIndex: 'submittedFor',
    key: 'submittedFor',
    sorter: true
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    sorter: true
  },
  {
    title: 'Submission Date',
    dataIndex: 'submissionDate',
    key: 'submissionDate',
    sorter: true
  },
  {
    title: 'Submission Time',
    dataIndex: 'submissionTime',
    key: 'submissionTime',
    sorter: true
  },
  {
    title: 'Location',
    dataIndex: 'locationType',
    key: 'locationType',
    render: (_, { locationType }) => (locationType === 1 ? 'Yard' : 'Classroom')
  },
  {
    title: 'Branch',
    dataIndex: 'branch',
    key: 'branch'
  }
];
